import type { App } from 'vue'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { getOrInitFirebase, getPersistentAuth, isFirebaseEnabled } from './firebase-core'

export { getPersistentAuth, firebaseConfig } from './firebase-core'

export function install(app: App) {
  if (!isFirebaseEnabled()) {
    console.warn('Skipping Firebase setup: invalid or missing Firebase environment configuration.')
    return
  }

  const firebaseApp = getOrInitFirebase()

  onAuthStateChanged(getAuth(), async (user) => {
    // Lazy import to avoid circular dependency at module load time
    const { useAuthStore } = await import('@/stores/useAuthStore')
    const authStore = useAuthStore()
    authStore.setEmail(user ? user.email : null)
  })

  app.config.globalProperties.$firebase = firebaseApp
  app.config.globalProperties.$getAuth = getPersistentAuth
}

export default { install }
